/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { FinancialSeries } from "./FinancialSeries";
import { ITrendLineSeries_$type } from "./ITrendLineSeries";
import { TrendLineType_$type } from "igniteui-react-core";
import { DependencyProperty } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { PenLineCap_$type } from "igniteui-react-core";
import { DoubleCollection } from "igniteui-react-core";
import { PriceDisplayType_$type } from "./PriceDisplayType";
import { Series } from "./Series";
import { Defaults } from "./Defaults";
import { enumGetBox, EnumUtil, typeCast, fromEnum, runOn, Point_$type, markType, markDep } from "igniteui-react-core";
import { CategoryFrame } from "./CategoryFrame";
import { ISortingAxis_$type } from "./ISortingAxis";
import { FinancialSeriesView } from "./FinancialSeriesView";
import { Rect } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { RectUtil } from "igniteui-react-core";
import { CategoryTrendLineManagerFactory } from "./CategoryTrendLineManagerFactory";
import { AxisRange } from "./AxisRange";
import { ScalerParams } from "./ScalerParams";
import { TrendResolutionParams } from "./TrendResolutionParams";
import { Pool$1 } from "igniteui-react-core";
import { Path } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { PathGeometry } from "igniteui-react-core";
import { PathFigure } from "igniteui-react-core";
import { LineSegment } from "igniteui-react-core";
import { GeometryGroup } from "igniteui-react-core";
import { LineGeometry } from "igniteui-react-core";
import { RectangleGeometry } from "igniteui-react-core";
import { DataLegendSeriesValueInfo } from "igniteui-react-core";
import { DataLegendSeriesContext } from "igniteui-react-core";
import { PropertyMetadata } from "igniteui-react-core";
import { truncate, isNaN_, isInfinity } from "igniteui-react-core";
import { boxArray$1 } from "igniteui-react-core";
import { round10N } from "igniteui-react-core";
import { FinancialPriceBucketCalculator } from "./FinancialPriceBucketCalculator";
import { Extensions } from "igniteui-react-core";
/**
 * @hidden
 */
var FinancialPriceSeries = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FinancialPriceSeries, _super);
    function FinancialPriceSeries() {
        var _this = _super.call(this) || this;
        _this.tx = true;
        _this.ty = 0;
        _this.tz = 0;
        _this.ab = FinancialPriceSeries.$;
        _this.qo = new CategoryFrame(5);
        _this.qq = new CategoryFrame(5);
        _this.qm = new CategoryFrame(5);
        return _this;
    }
    FinancialPriceSeries.prototype.get_dv = function () {
        return true;
    };
    FinancialPriceSeries.prototype.gz = function () {
        if (!isNaN_(this.gy)) {
            return _super.prototype.gz.call(this);
        }
        return Defaults.k;
    };
    FinancialPriceSeries.prototype.by = function () {
        return new FinancialPriceSeriesView(this);
    };
    FinancialPriceSeries.prototype.l4 = function (a) {
        _super.prototype.l4.call(this, a);
        this.tv = a;
    };
    Object.defineProperty(FinancialPriceSeries.prototype, "u7", {
        get: function () {
            return this.c(FinancialPriceSeries.up);
        },
        set: function (a) {
            this.h(FinancialPriceSeries.up, a);
        },
        enumerable: false,
        configurable: true
    });
    FinancialPriceSeries.prototype.k5 = function (a, b, c, d) {
        _super.prototype.k5.call(this, a, b, c, d);
        if (this.qk != null && typeCast(ISortingAxis_$type, this.qk) !== null) {
            this.qk.i$i();
        }
        this.tv.bx.e(this.fx);
        if (this.tv.b7) {
            this.tv.b5.g$e(a, b, c, d);
        }
        if (this.q6 != null) {
            this.q6.c1();
        }
        this.mn(true);
        if (a == 0 || a == 2 || a == 3 || a == 4) {
            this.tx = true;
        }
        else if (a == 1) {
            for (var e = b; e < b + c; e++) {
                var f = 0;
                f += this.re.item(e);
                f += this.rf.item(e);
                f += this.rd.item(e);
                this.ty += f / 3;
            }
            this.tz = this.ty / this.re.count;
        }
    };
    FinancialPriceSeries.prototype.bq = function () {
        if (this.br == 0) {
            return 1;
        }
        else {
            return _super.prototype.bq.call(this);
        }
    };
    FinancialPriceSeries.prototype.p3 = function (a) {
        if (this.qm == null || this.qm.f.count == 0) {
            return Rect.empty;
        }
        var b = this.pn(a);
        var c = this.b1.bv;
        var d = this.b1.bu;
        var e = this.getEffectiveViewport1(this.b1);
        var f = this.aj(this.qk, this.qm.f, this.sh(this.b1), this.sj(this.b1), a, true);
        var g = f[0];
        var h = f[1];
        var i = Math.abs(b.x - g[0]);
        var j = Math.abs(b.x - h[0]);
        var k = this.t0(this.q1, e);
        k = Math.max(k, 3);
        var l = (k - 1) / 2;
        if (i < j) {
            var m = g[0] - l;
            var n = g[0];
            var o = g[0] + l;
            var p = g[1];
            var q = g[2];
            var r = g[3];
            var s = g[4];
            var t = Math.min(Math.min(Math.min(p, q), r), s);
            var u = Math.max(Math.max(Math.max(p, q), r), s);
            return new Rect(0, m, t, Math.abs(o - m), u - t);
        }
        else {
            var v = h[0] - l;
            var w = h[0];
            var x = h[0] + l;
            var y = h[1];
            var z = h[2];
            var aa = h[3];
            var ab = h[4];
            var ac = Math.min(Math.min(Math.min(y, z), aa), ab);
            var ad = Math.max(Math.max(Math.max(y, z), aa), ab);
            return new Rect(0, v, ac, Math.abs(x - v), ad - ac);
        }
    };
    FinancialPriceSeries.prototype.tu = function (a, b) {
        var c = a[0] - b;
        var d = a[0];
        var e = a[0] + b;
        var f = a[1];
        var g = a[2];
        var h = a[3];
        var i = a[4];
        var j = Math.min(Math.min(Math.min(f, g), h), i);
        var k = Math.max(Math.max(Math.max(f, g), h), i);
        var l = Math.min(g, h);
        var m = Math.max(g, h);
        var n = Math.min(f, i);
        var o = Math.max(f, i);
        if (this.tw == 1) {
            var p = new Array(3);
            var q = new Rect(0, c, f, b, 0);
            var r = new Rect(0, d, i, b, 0);
            var s = new Rect(0, d, l, 0, m - l);
            p[0] = q;
            p[1] = r;
            p[2] = s;
            return p;
        }
        else {
            var t = new Array(2);
            var u = new Rect(0, d, l, 0, m - l);
            var v = new Rect(0, c, n, b * 2, o - n);
            t[0] = u;
            t[1] = v;
            return t;
        }
    };
    FinancialPriceSeries.prototype.ak = function (a) {
        var b = new List$1(Rect.$, 0);
        var c = this.pn(a);
        var d = this.b1.bv;
        var e = this.b1.bu;
        var f = this.getEffectiveViewport1(this.b1);
        var g = this.aj(this.qk, this.qm.f, this.sh(this.b1), this.sj(this.b1), a, true);
        var h = g[0];
        var i = g[1];
        var j = Math.abs(c.x - h[0]);
        var k = Math.abs(c.x - i[0]);
        var l = this.t0(this.q1, f);
        l = Math.max(l, 3);
        var m = (l - 1) / 2;
        if (j < k) {
            return this.tu(h, m);
        }
        else {
            return this.tu(i, m);
        }
    };
    FinancialPriceSeries.prototype.ez = function (a, b) {
        if (this.e2(a, b)) {
            return true;
        }
        return false;
    };
    FinancialPriceSeries.prototype.e2 = function (a, b) {
        var c = this.p4(a);
        if (c.isEmpty) {
            return false;
        }
        var d = RectUtil.r(c, (this.fy / 2) + this.gc(b));
        if (d.containsPoint(a)) {
            var e = this.al(a);
            if (e != null) {
                for (var f = 0; f < e.length; f++) {
                    var g = e[f];
                    var h = RectUtil.r(g, (this.fy / 2) + this.gc(b));
                    if (h.containsPoint(a)) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    FinancialPriceSeries.prototype.l9 = function (a, b, c, d) {
        switch (b) {
            case FinancialSeries.$$p[9]:
                this.tv.cd();
                if (this.ce != null) {
                    this.ce.mc();
                }
                break;
            case "TrendLineType":
                var e = EnumUtil.getEnumValue(TrendLineType_$type, d);
                if (e != 0) {
                    this.tv.b5 = CategoryTrendLineManagerFactory.a(this.tv.b5, this.qk, this.nf, this, this.co);
                }
                break;
        }
        _super.prototype.l9.call(this, a, b, c, d);
        if (this.tv.b7 && this.tv.b5 != null && this.tv.b5.g$b(a, b, c, d)) {
            this.mn(false);
            this.lu();
        }
        switch (b) {
            case FinancialPriceSeries.$$p[2]:
                if (this.nf != null) {
                    this.uo();
                    this.m2();
                    this.qm.w();
                    this.td(this.qm, this.tv);
                }
                this.lu();
                break;
            case "ActualHighlightingMode":
                this.mn(true);
                break;
            case "TrendLineBrush":
                this.m1();
                break;
            case "TrendLineType":
                this.lu();
                break;
            case FinancialSeries.$$p[5]:
            case FinancialPriceSeries.$$p[7]:
                this.l6();
                break;
        }
    };
    FinancialPriceSeries.prototype.uo = function () {
        this.tv.ch();
        if (this.b0 != null) {
            this.b0.ch();
        }
    };
    FinancialPriceSeries.prototype.aq = function (a) {
        if (a != null && a == this.q6 && this.rf != null && !isNaN_(this.rf.minimum) && this.re != null && !isNaN_(this.re.maximum)) {
            return new AxisRange(this.rf.minimum, this.re.maximum);
        }
        return null;
    };
    FinancialPriceSeries.prototype.ar = function (a) {
        if (a.isEmpty && this.ce != null) {
            a = this.ce.tj;
        }
        if (this.rf == null || this.re == null) {
            return null;
        }
        var b = this.pz(this.b1);
        var c = new ScalerParams(0, a, this.ce.ty, this.qk.ch, this.getEffectiveViewport());
        var d = (this.qk.em(b.left, c));
        var e = (this.qk.em(b.right, c));
        if (this.qk.ch) {
            var f = d;
            d = e;
            e = f;
        }
        var g = null;
        if (this.qk.cn) {
            g = this.qk;
            d = g.i$f(d);
            e = g.i$f(e);
        }
        else {
            d = Math.floor(d);
            e = Math.ceil(e);
        }
        d = Math.max(0, Math.min(this.rf.count - 1, d));
        e = Math.max(0, Math.min(this.rf.count - 1, e));
        var h = 1.7976931348623157E+308;
        var i = -1.7976931348623157E+308;
        for (var j = truncate(d); j <= truncate(e); j++) {
            var k = j;
            if (g != null) {
                k = g.i$b._inner[j];
            }
            var l = this.rf.item(k);
            if (this.rf.mayContainUnknowns) {
                if (isInfinity(l) || isNaN_(l)) {
                    continue;
                }
            }
            var m = this.re.item(k);
            if (this.re.mayContainUnknowns) {
                if (isInfinity(m) || isNaN_(m)) {
                    continue;
                }
            }
            h = Math.min(h, l);
            i = Math.max(i, m);
        }
        var n = new AxisRange(h, i);
        n = this.ap(n, this.q6, a);
        return n;
    };
    FinancialPriceSeries.prototype.gg = function () {
        return Series.gh(this.rg, typeCast(ISortingAxis_$type, this.qk));
    };
    FinancialPriceSeries.prototype.eq = function (a) {
        var b = this.cl != null ? this.cl.indexOf(a) : -1;
        var c = this.b1.bv;
        c = c.copy();
        var d = this.b1.bu;
        var e = new Rect(0, 0, 0, 1, 1);
        var f = this.p1(this.b1);
        if (b >= 0 && Rect.l_op_Inequality(c, null) && Rect.l_op_Inequality(d, null)) {
            if (this.qk != null) {
                var g = new ScalerParams(0, e, e, this.qk.ch, f);
                var h = this.qk.ej(b, g);
                if (h < c.left + 0.1 * c.width) {
                    h = h + 0.4 * c.width;
                }
                if (h > c.right - 0.1 * c.width) {
                    h = h - 0.4 * c.width;
                }
                c.x = h - 0.5 * c.width;
            }
            if (this.q6 != null && this.rf != null && this.re != null && b < this.rf.count && b < this.re.count) {
                var i = new ScalerParams(0, e, e, this.q6.ch, f);
                i.b = this.gg();
                var j = this.q6.ej(this.rf.item(b), i);
                var k = this.q6.ej(this.re.item(b), i);
                if (!isNaN_(j) && !isNaN_(k)) {
                    var l = Math.abs(j - k);
                    if (c.height < l) {
                        c.height = l;
                        c.y = Math.min(j, k);
                    }
                    else {
                        if (j < c.top + 0.1 * c.height) {
                            j = j + 0.4 * c.height;
                        }
                        if (j > c.bottom - 0.1 * c.height) {
                            j = j - 0.4 * c.height;
                        }
                        c.y = j - 0.5 * c.height;
                    }
                }
            }
            this.b9.au(this.ce, c, true);
        }
        return b >= 0;
    };
    FinancialPriceSeries.prototype.fd = function (a, b, c) {
        var d = _super.prototype.fd.call(this, a, b, c);
        if (this.rg == null || this.rd == null || this.re == null || this.rf == null) {
            d = false;
        }
        return d;
    };
    FinancialPriceSeries.prototype.tb = function (a, b) {
        var e_1, _a;
        var _this = this;
        _super.prototype.tb.call(this, a, b);
        var c = b.bv;
        var d = b.bu;
        var e = this.getEffectiveViewport1(b);
        var f = this.qk;
        var g = this.q6;
        var h = new ScalerParams(0, c, d, f.ch, e);
        var i = ((function () {
            var $ret = new ScalerParams(0, c, d, g.ch, e);
            $ret.b = _this.gg();
            return $ret;
        })());
        a.f.clear();
        a.m.clear();
        a.p.clear();
        var j = 0;
        var k = typeCast(ISortingAxis_$type, this.qk);
        if (k != null && (k.i$b == null || k.i$b.count != this.cl.count)) {
            return;
        }
        j = this.sb(c, d, e);
        var l = typeCast(FinancialPriceSeriesView.$, b);
        var m = this.fx;
        if (this.trendLineType != 0) {
            var n = new Array(this.cl.count);
            var o = 0;
            try {
                for (var _b = __values(fromEnum(this.r2)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var p = _c.value;
                    n[o] = p;
                    o++;
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            if (this.tv.b7) {
                this.tv.b5.prepareLineCore(a.p, this.trendLineType, boxArray$1(n), this.trendLinePeriod, function (q) { return _this.qk.ej(q, h); }, function (q) { return _this.q6.ej(q, i); }, ((function () {
                    var $ret = new TrendResolutionParams();
                    $ret.e = b.bx.b;
                    $ret.f = b.bx.c;
                    $ret.g = b.bx.d;
                    $ret.a = j;
                    $ret.d = m;
                    $ret.h = d;
                    return $ret;
                })()));
            }
        }
        var q = this.qk.em(2, h) - this.qk.em(1, h);
        for (var r = b.bx.c; r <= b.bx.d; ++r) {
            var s = void 0;
            if (k == null) {
                s = b.bx.getBucket(r);
            }
            else {
                var t = k.i$b._inner[r];
                var u = k.i$d(t);
                var v = this.rg.item(t);
                var w = this.re.item(t);
                var x = this.rf.item(t);
                var y = this.rd.item(t);
                var z = v;
                var aa = w;
                var ab = x;
                var ac = y;
                var ad = u;
                while (r < b.bx.d) {
                    t = k.i$b._inner[r + 1];
                    ad = k.i$d(t);
                    if (ad - u > q * m) {
                        break;
                    }
                    r++;
                    aa = Math.max(aa, this.re.item(t));
                    ab = Math.min(ab, this.rf.item(t));
                    ac = this.rd.item(t);
                }
                var ae = NaN;
                if (!isNaN_(u)) {
                    ae = this.qk.ej(u, h);
                }
                s = [ae, z, aa, ab, ac];
            }
            if (!isNaN_(s[0])) {
                if (k != null) {
                    s[0] = s[0] + j;
                }
                else {
                    s[0] = f.ej(s[0], h) + j;
                }
                s[1] = g.ej(s[1], i);
                s[2] = g.ej(s[2], i);
                s[3] = g.ej(s[3], i);
                s[4] = g.ej(s[4], i);
                a.f.add(s);
            }
        }
        return;
    };
    FinancialPriceSeries.prototype.k2 = function (a, b) {
        _super.prototype.k2.call(this, a, b);
        var c = typeCast(FinancialPriceSeriesView.$, b);
        c.cb();
        if (a) {
            c.b6.count = 0;
        }
        if (c.b7 && c.b5 != null) {
            c.b5.g$d();
        }
    };
    FinancialPriceSeries.prototype.na = function (a, b) {
        _super.prototype.na.call(this, a, b);
        if (this.ce != null) {
            this.ce.mc();
        }
    };
    FinancialPriceSeries.prototype.p9 = function (a, b) {
        if (this.qk != null && this.qk.categoryMode == 0) {
            var c = this.getEffectiveViewport1(this.b1);
            var d = this.t0(this.q1, c) / 2;
            return new Thickness(1, d, 0, d, 0);
        }
        return _super.prototype.p9.call(this, a, b);
    };
    FinancialPriceSeries.prototype.get_c3 = function () {
        return true;
    };
    FinancialPriceSeries.prototype.td = function (a, b) {
        _super.prototype.td.call(this, a, b);
        if (this.qk == null || this.q6 == null) {
            return;
        }
        var c = false;
        if (b.b0(a)) {
            c = true;
            b.b2(a);
        }
        this.qt.a2(this, this.rs(), runOn(this, this.qc), this.sh(b), this.sj(b));
        var d = false;
        var e = this.qt.b;
        if (e != null) {
            d = true;
        }
        var f = typeCast(FinancialPriceSeriesView.$, b);
        f.ca();
        f.b8 = false;
        if (f.b7) {
            f.b5.g$d();
        }
        if (this.trendLineType != 0) {
            f.b5.g$g(a.p);
        }
        if (d) {
            this.um(a, b, c);
        }
        else {
            f.b6.count = 0;
            this.ul(a, b);
        }
    };
    FinancialPriceSeries.prototype.ge = function () {
        var a = this.getEffectiveViewport1(this.b1);
        return this.t0(this.q1, a);
    };
    FinancialPriceSeries.prototype.um = function (a, b, c) {
        var d = this.tw;
        var e = this.getEffectiveViewport1(b);
        var f = this.t0(b, e);
        var g = (f - 1) / 2;
        var h = typeCast(FinancialPriceSeriesView.$, b);
        h.b8 = true;
        var i = a.f;
        var j = 0;
        var k = this.cl.count;
        var l = this.qk;
        var m = new ScalerParams(0, b.bv, b.bu, l.ch, e);
        var n = this.o5;
        var o = this.tq;
        if (o == null) {
            o = n;
        }
        var p = this.o8;
        var q = this.u8;
        if (q == null) {
            q = p;
        }
        var _loop_1 = function (r) {
            var s = i._inner[r][0] - g;
            var t = i._inner[r][0];
            var u = i._inner[r][0] + g;
            var v = i._inner[r][1];
            var w = i._inner[r][2];
            var x = i._inner[r][3];
            var y = i._inner[r][4];
            if (isNaN_(v) || isNaN_(w) || isNaN_(x) || isNaN_(y)) {
                return "continue";
            }
            var z = h.b6.item(j);
            j++;
            var aa = v < y;
            var ab = new PathGeometry();
            if (c) {
                switch (d) {
                    case 0:
                        if (aa) {
                            var ac = v;
                            v = y;
                            y = ac;
                        }
                        var ad = new PathFigure();
                        ad._startPoint = { $type: Point_$type, x: t, y: x };
                        ad._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: t, y: v };
                            return $ret;
                        })()));
                        var ae = new PathFigure();
                        ae._startPoint = { $type: Point_$type, x: s, y: y };
                        ae._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: u, y: y };
                            return $ret;
                        })()));
                        ae._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: u, y: v };
                            return $ret;
                        })()));
                        ae._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: s, y: v };
                            return $ret;
                        })()));
                        ae._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: s, y: y };
                            return $ret;
                        })()));
                        var af = new PathFigure();
                        af._startPoint = { $type: Point_$type, x: t, y: y };
                        af._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: t, y: w };
                            return $ret;
                        })()));
                        ab.c.add(ad);
                        ab.c.add(ae);
                        ab.c.add(af);
                        break;
                    case 1:
                        var ag = new PathFigure();
                        ag._startPoint = { $type: Point_$type, x: s, y: v };
                        ag._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: t, y: v };
                            return $ret;
                        })()));
                        var ah = new PathFigure();
                        ah._startPoint = { $type: Point_$type, x: t, y: x };
                        ah._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: t, y: w };
                            return $ret;
                        })()));
                        var ai = new PathFigure();
                        ai._startPoint = { $type: Point_$type, x: t, y: y };
                        ai._segments.add(((function () {
                            var $ret = new LineSegment(1);
                            $ret.c = { $type: Point_$type, x: u, y: y };
                            return $ret;
                        })()));
                        ab.c.add(ag);
                        ab.c.add(ah);
                        ab.c.add(ai);
                        break;
                }
            }
            if (aa) {
                this_1.qt.ak = o;
                this_1.qt.ag = o;
                this_1.qt.ah = q;
                this_1.qt.al = q;
                this_1.qt.f = true;
            }
            else {
                this_1.qt.ak = n;
                this_1.qt.ag = n;
                this_1.qt.ah = p;
                this_1.qt.al = p;
                this_1.qt.f = false;
            }
            this_1.ta(i, r, k, l, m, b.q);
            if (d == 1) {
                this_1.qt.ad(z, true, false, false, false);
            }
            else {
                this_1.qt.ad(z, false, false, false, false);
            }
            if (c) {
                z.an = ab;
            }
        };
        var this_1 = this;
        for (var r = 0; r < i.count; ++r) {
            _loop_1(r);
        }
        h.b6.count = j;
        h.cc();
    };
    FinancialPriceSeries.prototype.t0 = function (a, b) {
        var c = this.qk.k4(a.bv, a.bu, b);
        c = Math.max(c, this.fx * 0.9);
        c = Math.max(c, 3);
        return c;
    };
    FinancialPriceSeries.prototype.ul = function (a, b) {
        var c = this.tw;
        var d = this.getEffectiveViewport1(b);
        var e = this.t0(b, d);
        var f = (e - 1) / 2;
        var g = typeCast(FinancialPriceSeriesView.$, b);
        var h = g.ck();
        var i = g.cj();
        var j = a.f;
        var _loop_2 = function (k) {
            var l = j._inner[k][0] - f;
            var m = j._inner[k][0];
            var n = j._inner[k][0] + f;
            var o = j._inner[k][1];
            var p = j._inner[k][2];
            var q = j._inner[k][3];
            var r = j._inner[k][4];
            if (isNaN_(o) || isNaN_(p) || isNaN_(q) || isNaN_(r)) {
                return "continue";
            }
            var s = o < r;
            var t = s ? i : h;
            switch (c) {
                case 0:
                    if (s) {
                        var u = o;
                        o = r;
                        r = u;
                    }
                    t.d.add(((function () {
                        var $ret = new LineGeometry();
                        $ret.d = { $type: Point_$type, x: m, y: q };
                        $ret.c = { $type: Point_$type, x: m, y: o };
                        return $ret;
                    })()));
                    t.d.add(((function () {
                        var $ret = new RectangleGeometry();
                        $ret.e = new Rect(0, l, r, n - l, o - r);
                        return $ret;
                    })()));
                    t.d.add(((function () {
                        var $ret = new LineGeometry();
                        $ret.d = { $type: Point_$type, x: m, y: r };
                        $ret.c = { $type: Point_$type, x: m, y: p };
                        return $ret;
                    })()));
                    break;
                case 1:
                    t.d.add(((function () {
                        var $ret = new LineGeometry();
                        $ret.d = { $type: Point_$type, x: l, y: o };
                        $ret.c = { $type: Point_$type, x: m, y: o };
                        return $ret;
                    })()));
                    t.d.add(((function () {
                        var $ret = new LineGeometry();
                        $ret.d = { $type: Point_$type, x: m, y: q };
                        $ret.c = { $type: Point_$type, x: m, y: p };
                        return $ret;
                    })()));
                    t.d.add(((function () {
                        var $ret = new LineGeometry();
                        $ret.d = { $type: Point_$type, x: m, y: r };
                        $ret.c = { $type: Point_$type, x: n, y: r };
                        return $ret;
                    })()));
                    break;
            }
        };
        for (var k = 0; k < j.count; ++k) {
            _loop_2(k);
        }
    };
    FinancialPriceSeries.prototype.h4 = function (a, b) {
        if (this.tv.b7 && a == this.tv.b5.g$j) {
            return null;
        }
        return _super.prototype.h4.call(this, a, b);
    };
    FinancialPriceSeries.prototype.m1 = function () {
        _super.prototype.m1.call(this);
        if (this.index < 0) {
            return;
        }
        this.tv.ci();
    };
    FinancialPriceSeries.prototype.lc = function (a) {
        _super.prototype.lc.call(this, a);
        if (this.tv.b7) {
            this.a9.exportTrendlineData(this, a, this.tv.b5.g$j);
        }
    };
    FinancialPriceSeries.prototype.pg = function () {
        return this.u8;
    };
    FinancialPriceSeries.prototype.ms = function (a, b) {
        _super.prototype.ms.call(this, a, b);
        this.u8 = b;
    };
    FinancialPriceSeries.prototype.bb = function (a) {
        if (this.tw == 0) {
            return 3;
        }
        else if (this.tw == 1) {
            if (this.ba == 1) {
                return 3;
            }
            return 2;
        }
        return a;
    };
    FinancialPriceSeries.prototype.getDataLegendSeriesContextAt = function (a, b) {
        var c = { $type: Point_$type, x: a, y: b };
        var d = this.gl(c, false, false);
        var e = this.gj(c, false, false);
        var f = new DataLegendSeriesValueInfo();
        f.a = 4;
        f.l = this.sc(c, false, false);
        f.p = "Close";
        f.q = this.so != null ? this.so : "Close";
        f.r = this.t3 != null ? this.t3 : "C:";
        f.s = this.t5 != null ? this.t5 : "";
        var g = new DataLegendSeriesValueInfo();
        g.l = this.sd(c, false, false);
        g.a = 3;
        g.p = "Open";
        g.q = this.s0 != null ? this.s0 : "Open";
        g.r = this.uh != null ? this.uh : "O:";
        g.s = this.uj != null ? this.uj : "";
        g.k = true;
        var h = new DataLegendSeriesValueInfo();
        h.l = (f.l - g.l) / g.l * 100;
        h.l = round10N(h.l, 1);
        h.a = 9;
        h.p = "Change";
        h.q = "Change";
        h.r = "";
        h.u = "";
        h.w = "+";
        h.v = "%";
        h.x = "%";
        h.s = null;
        h.c = false;
        h.k = true;
        h.e = false;
        h.f = true;
        h.h = false;
        h.g = false;
        h.d = false;
        h.n = 1;
        h.m = 1;
        g.y = h.l >= 0 ? this.o5 : this.tq;
        f.y = h.l >= 0 ? this.o5 : this.tq;
        h.y = h.l >= 0 ? this.o5 : this.tq;
        var i = new DataLegendSeriesValueInfo();
        i.l = e > d ? d : e;
        i.a = 1;
        i.p = "Low";
        i.q = this.sw != null ? this.sw : "Low";
        i.r = this.uc != null ? this.uc : "L:";
        i.s = this.ue != null ? this.ue : "";
        i.k = true;
        var j = new DataLegendSeriesValueInfo();
        j.l = e > d ? e : d;
        j.a = 2;
        j.p = "High";
        j.q = this.sr != null ? this.sr : "High";
        j.r = this.t8 != null ? this.t8 : "H:";
        j.s = this.ua != null ? this.ua : "";
        j.k = true;
        var k = new DataLegendSeriesValueInfo();
        k.l = (j.l + i.l + f.l) / 3;
        k.l = round10N(k.l, 2);
        k.a = 5;
        k.p = "TypicalPrice";
        k.q = "TypicalPrice";
        k.r = "TP:";
        k.s = "";
        k.k = true;
        var l = new DataLegendSeriesValueInfo();
        l.l = this.se(c, false, false);
        l.a = 8;
        l.p = "Volume";
        l.q = this.s4 != null ? this.s4 : "Volume";
        l.r = "VOL:";
        l.s = "";
        l.k = true;
        l.n = 0;
        l.m = 0;
        l.e = false;
        l.f = false;
        l.h = false;
        var m = new List$1(DataLegendSeriesValueInfo.$, 0);
        m.add(g);
        m.add(j);
        m.add(i);
        m.add(f);
        m.add(k);
        m.add(h);
        m.add(l);
        var n = new DataLegendSeriesContext();
        n.b = this.aw();
        n.f = m;
        return n;
    };
    FinancialPriceSeries.prototype.un = function () {
        if (this.tx) {
            this.ty = 0;
            for (var a = 0; a < this.re.count; a++) {
                var b = 0;
                b += this.re.item(a);
                b += this.rf.item(a);
                b += this.rd.item(a);
                this.ty += b / 3;
            }
            this.tz = this.ty / this.re.count;
            this.tx = false;
        }
    };
    FinancialPriceSeries.prototype.am = function (a) {
        var b = NaN;
        switch (a) {
            case 2:
                b = this.re.maximum;
                break;
            case 1:
                b = this.rf.minimum;
                break;
            case 3:
                if (this.tx) {
                    this.un();
                }
                b = this.tz;
                break;
        }
        var c = this.q6;
        if (c.cp) {
            return [NaN, b];
        }
        else {
            return [b, NaN];
        }
    };
    FinancialPriceSeries.prototype.pv = function (a) {
        var b = NaN;
        switch (a) {
            case 2:
                b = this.re.maximum;
                break;
            case 1:
                b = this.rf.minimum;
                break;
            case 3:
                if (this.tx) {
                    this.un();
                }
                b = this.tz;
                break;
        }
        if (isNaN_(b)) {
            return { $type: Point_$type, x: NaN, y: NaN };
        }
        var c = this.q6;
        var d = this.getEffectiveViewport1(this.b1);
        var e = new ScalerParams(0, this.b1.bv, this.b1.bu, c.ch, d);
        if (c.cp) {
            e.b = this.gg();
        }
        e.c = d;
        if (c.cp) {
            return { $type: Point_$type, x: NaN, y: c.ej(b, e) };
        }
        else {
            return { $type: Point_$type, x: c.ej(b, e), y: NaN };
        }
    };
    FinancialPriceSeries.prototype.pw = function (a) {
        var b = this.q6;
        var c = this.getEffectiveViewport1(this.b1);
        var d = new ScalerParams(0, this.b1.bv, this.b1.bu, b.ch, c);
        if (b.cp) {
            d.b = this.gg();
        }
        d.c = c;
        if (b.cp) {
            return { $type: Point_$type, x: NaN, y: b.ej(a[1], d) };
        }
        else {
            return { $type: Point_$type, x: b.ej(a[0], d), y: NaN };
        }
    };
    FinancialPriceSeries.$t = markType(FinancialPriceSeries, 'FinancialPriceSeries', FinancialSeries.$, [ITrendLineSeries_$type]);
    FinancialPriceSeries.up = DependencyProperty.i("ActualTrendLineBrush", Brush.$, FinancialPriceSeries.$, new PropertyMetadata(2, null, function (a, b) { return a.raisePropertyChanged("ActualTrendLineBrush", b.oldValue, b.newValue); }));
    FinancialPriceSeries.$$p = markDep(DependencyProperty, PropertyMetadata, FinancialPriceSeries, 'raisePropertyChanged', ['CloseMemberAsLegendLabel:t3:uq', [2, null], 'CloseMemberAsLegendUnit:t5:ur', [2, null], 'DisplayType:tw:us', [PriceDisplayType_$type, enumGetBox(PriceDisplayType_$type, 0)], 'HighMemberAsLegendLabel:t8:ut', [2, null], 'HighMemberAsLegendUnit:ua:uu', [2, null], 'LowMemberAsLegendLabel:uc:uv', [2, null], 'LowMemberAsLegendUnit:ue:uw', [2, null], 'NegativeOutline:u8:ux', [Brush.$, null], 'OpenMemberAsLegendLabel:uh:uy', [2, null], 'OpenMemberAsLegendUnit:uj:uz', [2, null], 'TrendLineType::u5', [TrendLineType_$type, enumGetBox(TrendLineType_$type, 0)], 'TrendLineThickness::u4', [1, 1.5], 'TrendLinePeriod::u3', [1, 7], 'TrendLineBrush::u0', [Brush.$, null], 'TrendLineZIndex:t2:u6', [1, 1001], 'TrendLineDashArray:u9:u1', [DoubleCollection.$], 'TrendLineDashCap:va:u2', [PenLineCap_$type, enumGetBox(PenLineCap_$type, 0)]]);
    return FinancialPriceSeries;
}(FinancialSeries));
export { FinancialPriceSeries };
/**
 * @hidden
 */
var FinancialPriceSeriesView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FinancialPriceSeriesView, _super);
    function FinancialPriceSeriesView(a) {
        var _this = _super.call(this, a) || this;
        _this.b3 = null;
        _this.b6 = null;
        _this.b9 = null;
        _this.cn = ((function () {
            var $ret = new Path();
            $ret.an = new GeometryGroup();
            return $ret;
        })());
        _this.cm = ((function () {
            var $ret = new Path();
            $ret.an = new GeometryGroup();
            return $ret;
        })());
        _this.b4 = null;
        _this.cl = new Path();
        _this.b8 = false;
        _this.b3 = a;
        _this.b9 = new List$1(Path.$, 0);
        _this.b6 = ((function () {
            var $ret = new Pool$1(Path.$);
            $ret.create = runOn(_this, _this.co);
            $ret.activate = runOn(_this, _this.ce);
            $ret.disactivate = runOn(_this, _this.cg);
            $ret.destroy = runOn(_this, _this.cf);
            return $ret;
        })());
        return _this;
    }
    FinancialPriceSeriesView.prototype.co = function () {
        var a = new Path();
        this.b9.add(a);
        a._visibility = 1;
        return a;
    };
    FinancialPriceSeriesView.prototype.ce = function (a) {
        a._visibility = 0;
    };
    FinancialPriceSeriesView.prototype.cg = function (a) {
        a._visibility = 1;
    };
    FinancialPriceSeriesView.prototype.cf = function (a) {
        this.b9.remove(a);
    };
    FinancialPriceSeriesView.prototype.by = function () {
        return new FinancialPriceBucketCalculator(this);
    };
    FinancialPriceSeriesView.prototype.as = function () {
        _super.prototype.as.call(this);
        if (!this.q) {
            this.b3.tw = Defaults.g;
            this.b3.tq = Defaults.ah;
            this.b3.u8 = Defaults.ai;
            this.b3.g4 = Defaults.l;
            this.b3.pe = this.b3.o8;
        }
    };
    Object.defineProperty(FinancialPriceSeriesView.prototype, "b5", {
        get: function () {
            if (this.b4 == null) {
                this.b4 = CategoryTrendLineManagerFactory.a(this.b4, this.e.as(), this.e.nf, this.e, this.e.co);
            }
            return this.b4;
        },
        set: function (a) {
            this.b4 = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialPriceSeriesView.prototype, "b7", {
        get: function () {
            return this.b4 != null;
        },
        enumerable: false,
        configurable: true
    });
    FinancialPriceSeriesView.prototype.ch = function () {
        if (this.b3.tw == 1) {
            this.cn._stroke = this.e.o5;
        }
        else {
            this.cn._stroke = this.e.o8;
        }
        if (this.b3.tw == 1) {
            this.cm._stroke = this.bz.tq;
        }
        else {
            this.cm._stroke = this.b3.u8;
        }
    };
    FinancialPriceSeriesView.prototype.cb = function () {
        this.aq();
        this.b6.count = 0;
        this.ca();
    };
    FinancialPriceSeriesView.prototype.ca = function () {
        var a = typeCast(GeometryGroup.$, this.cn.an);
        var b = typeCast(GeometryGroup.$, this.cm.an);
        Extensions.d(a);
        Extensions.d(b);
    };
    FinancialPriceSeriesView.prototype.ck = function () {
        this.aq();
        return typeCast(GeometryGroup.$, this.cn.an);
    };
    FinancialPriceSeriesView.prototype.cj = function () {
        this.aq();
        return typeCast(GeometryGroup.$, this.cm.an);
    };
    FinancialPriceSeriesView.prototype.ci = function () {
        this.b3.u7 = null;
        if (this.b3.trendLineBrush != null) {
            this.b3.u7 = this.b3.trendLineBrush;
        }
        else {
            this.b3.u7 = this.b3.o5;
        }
    };
    FinancialPriceSeriesView.prototype.bb = function () {
        _super.prototype.bb.call(this);
        this.cn.ad = this.e.fy;
        this.cn.ai = this.e.pi;
        this.cn.aj = this.e.pj;
        if (this.b3.tw == 1) {
            this.cn._stroke = this.e.o5;
        }
        else {
            this.cn._stroke = this.e.o8;
            this.cn._fill = this.e.o5;
        }
        this.cm.ad = this.e.fy;
        this.cm.ai = this.e.pi;
        this.cm.aj = this.e.pj;
        if (this.b3.tw == 1) {
            this.cm._stroke = this.bz.tq;
        }
        else {
            this.cm._stroke = this.b3.u8;
            this.cm._fill = this.bz.tq;
        }
    };
    FinancialPriceSeriesView.prototype.bc = function () {
        _super.prototype.bc.call(this);
        var a = this.bo();
        this.cn.ad = this.e.fy + 3;
        if (this.b3.tw == 1) {
            this.cn._stroke = a;
        }
        else {
            this.cn._stroke = a;
            this.cn._fill = a;
        }
        this.cm.ad = this.e.fy + 3;
        if (this.b3.tw == 1) {
            this.cm._stroke = a;
        }
        else {
            this.cm._stroke = a;
            this.cm._fill = a;
        }
    };
    FinancialPriceSeriesView.prototype.ac = function (a) {
        return this.b9._inner[a];
    };
    FinancialPriceSeriesView.prototype.ab = function (a) {
        var b = this.b9._inner[a];
        this.cl._visibility = b._visibility;
        this.cl.an = b.an;
        var c = this.bp(a);
        this.cl._fill = c;
        this.cl._stroke = c;
        this.cl.ad = this.e.fy + 3;
        return this.cl;
    };
    FinancialPriceSeriesView.prototype.a6 = function (a, b) {
        _super.prototype.a6.call(this, a, b);
        if (a.d) {
            if (this.b8) {
                for (var c = 0; c < this.b9.count; c++) {
                    var d = this.aa(c, b);
                    if (d._visibility == 0) {
                        a.t(d);
                    }
                }
            }
            else {
                a.t(this.cn);
                a.t(this.cm);
            }
        }
    };
    FinancialPriceSeriesView.prototype.a5 = function (a, b) {
        if (a.d) {
            if (this.b3.trendLineType != 0 && !b) {
                var c = this.b5.g$j;
                c.ad = this.b3.trendLineThickness;
                c._stroke = this.b3.u7;
                c.ai = this.b3.u9;
                c.aj = this.b3.va;
                a.v(c);
            }
        }
        _super.prototype.a5.call(this, a, b);
    };
    FinancialPriceSeriesView.prototype.al = function (a) {
        _super.prototype.al.call(this, a);
        if (this.b3.rs()) {
            for (var b = 0; b < this.b9.count; b++) {
                var c = this.b9._inner[b];
                if (c._fill == this.b3.tq) {
                    this.e.a9.exportPathData(a, c, "negativePathShape" + b, ["Negative"]);
                }
                else {
                    this.e.a9.exportPathData(a, c, "positivePathShape" + b, ["Positive", "Main"]);
                }
            }
        }
        else {
            this.e.a9.exportPathData(a, this.cn, "positivePathShape", ["Positive", "Main"]);
            this.e.a9.exportPathData(a, this.cm, "negativePathShape", ["Negative"]);
        }
    };
    FinancialPriceSeriesView.prototype.cc = function () {
        this.aq();
    };
    FinancialPriceSeriesView.prototype.cd = function () {
        if (this.b7) {
            this.b4 = CategoryTrendLineManagerFactory.a(this.b4, this.e.as(), this.e.nf, this.e, this.e.co);
        }
    };
    FinancialPriceSeriesView.$t = markType(FinancialPriceSeriesView, 'FinancialPriceSeriesView', FinancialSeriesView.$);
    return FinancialPriceSeriesView;
}(FinancialSeriesView));
export { FinancialPriceSeriesView };
